import { ContextUtil } from '../context';

export default class Formula {
  static resolve = (expression) => {
    const parameterized = this.replaceParamInExpression(expression);
    if (!parameterized) return '';
    let computedValue = eval(parameterized);
    if (!isNaN(computedValue)) {
      computedValue = Math.floor(computedValue * 100) / 100;
    }

    return computedValue;
  };

  static replaceParamInExpression = (expression) => {
    let result = expression;
    const groups = result.match(/{(\S*)}/);
    if (groups && groups.length > 1) {
      for (let i = 1; i < groups.length; i += 1) {
        const value = ContextUtil.getParamFromContext(groups[i]);
        if (value !== undefined && value != null && value !== '') {
          const r = new RegExp(`{${groups[i]}}`, 'g');
          result = result.replace(r, value);
        } else {
          return false;
        }
      }
    }
    return result;
  };
}
